import React, { useEffect, useState } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { lang } from "moment/moment";

const Balance = ({ data, RefreshBalance }) => {
  const [languageData, setLanguageData] = useState(null);
  const [credits, setCredits] = useState("");
  const [offerCredits, setOfferCredits] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }
  const balance = data?.balance || [];
  const offerBalances = balance.filter((item) => item.source !== "order");
  const orderBalances = balance.filter((item) => item.source === "order");
  const formatDate = (date) => {
    if (!date) return "";

    return date.split(" ")[0];
  };
  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec)) return "00:00:00";

    const hrs = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const secs = String(sec % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };
  const formatRemaining = (subItem, parentItem) => {
    if (parentItem.unit === "period") {
      return formatTime(Number(subItem.remaining));
    }

    if (parentItem.unit === "volume") {
      const label =
        parentItem.communication_type === "call"
          ? languageData.communication.call
          : parentItem.communication_type === "email"
            ? "emails"
            : "messages";

      return `${subItem.remaining} ${label}`;
    }

    return subItem.remaining;
  };

  return (
    <>
      <div class="col-xxl-12 col-md-6 text-left">
        <div class="card custom-card">
          <div class="card-header d-flex justify-content-between">
            <div class="flex-1">
              <div class="card-title"> {languageData.balance.title}</div>
            </div>
          </div>
          <div className="card-body">
            <div className="d-flex align-items-start justify-content-between mb-1">
              <div className="flex-grow-1">
                {orderBalances.length > 0 ? (
                  orderBalances.map((item, index) => {
                    const items = item.items || [];
                    const hasMultipleItems = items.length > 1;
                    const hasOneItem = items.length === 1;

                    const tooltipId = `balance-tooltip-${index}`;

                    return (
                      <div
                        className="flex mb-3 gap-6p"
                        key={index}
                      >
                        <span className="bg-primary-transparent text-primary avatar avatar-lg br-10">
                          {item.communication_type === "call" ? (
                            <i className="bi bi-telephone-fill"></i>
                          ) : (
                            <i className="bi bi-chat-fill"></i>
                          )}
                        </span>
<div className="flex-grow-1">
                        <div className="flex align-items-center w-100">
                          <div className="flex flex-column w-100">
                            <h3 className="mb-1 font-26">
                              {item.unit === "period"
                                ? formatTime(Number(item.credit))
                                : item.credit}
                            </h3>
                            <div className="flex align-items-start justify-content-between fs-11 fw-400  gray_color ml-3p">
 <span
                             
                            >
                              {item.communication_type === "call"
                                ? languageData.communication.call
                                : item.communication_type}
                            </span>
                             {/* Multiple items */}
                          {hasMultipleItems && (
                            <div
                              className="fs-12 text-muted"
                              data-tooltip-id={tooltipId}
                              data-tooltip-place="bottom"
                            >
                              <i className="bi bi-clock"></i>{" "}
                              {languageData.balance.valid}
                              <Tooltip id={tooltipId} style={{zIndex:"99"}}>
                                <div>
                                  {items
                                    .filter((subItem) => subItem.date_end)
                                    .map((subItem, subIndex) => (
                                      <div key={subIndex}>
                                        {item.unit === "period"
                                          ? formatTime(
                                              Number(subItem.remaining),
                                            )
                                          : subItem.remaining}{" "}
                                           {item.communication_type === "call"
                                            ? languageData.communication.call
                                            : item.communication_type === "email"
                                              ? "emails"
                                              : "messages"} {" "}
                                        {languageData.balance.validity}{" "}
                                        {formatDate(subItem.date_end)}
                                      </div>
                                    ))}
                                </div>
                              </Tooltip>
                            </div>
                          )}
                            </div>
                           
                          </div>

                         

                          {/* Only one item */}
                          {hasOneItem && items[0].date_end && (
                            <div className="fs-12 text-muted">
                              {languageData.balance.validity}{" "}
                              {formatDate(items[0].date_end)}
                            </div>
                          )}
                        </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="flex mb-3 gap-6p">
                    <h3 className="mb-0 font-26">0</h3>
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center">
              <Link data-interaction="add_credits_button"
                to={`/plans`}
                className="flex-grow-1 btn btn-primary me-2"
              >
                {languageData.balance.add_credits}
              </Link>
              <Link data-interaction="history_button"
                to={`/payments`}
                className="min-w-fit-content btn btn-outline-primary"
                data-tooltip-id="history_tooltip"
                data-tooltip-content={languageData.balance.history_btn}
                data-tooltip-place="bottom"
              >
                <i className="ti ti-wallet"></i>
              </Link>
              <Tooltip id="history_tooltip" />
            </div>
          </div>
        </div>{" "}
        {offerBalances.length > 0 && (
          <div class="card custom-card">
            <div class="card-header d-flex justify-content-between">
              <div class="flex-1">
                <div class="card-title"> {languageData.offer.title}</div>
              </div>
            </div>
            <div className="card-body">
              <div className="d-flex align-items-start justify-content-between mb-1 flex-column gap-10">
                {offerBalances.map((item, index) => {
                  const items = item.items || [];
                  const hasMultipleItems = items.length > 1;
                  const hasOneItem = items.length === 1;
                  const tooltipId = `offer-balance-tooltip-${index}`;
                  return (
                    <div key={index} className="w-100">
                      <div
                        className="flex align-items-center gap-6p"
                
                      >
                        <span className="bg-primary-transparent text-primary avatar avatar-lg br-10">
                          {item.communication_type === "call" ? (
                            <i className="bi bi-telephone-fill"></i>
                          ) : (
                            <i className="bi bi-chat-fill"></i>
                          )}
                        </span>

                        <div className="flex-grow-1">
                          <div className="flex align-items-start justify-content-between w-100">
                            <div className="flex flex-column w-100">
                              <h3 className="mb-1 font-26">
                                {item.unit === "period"
                                  ? formatTime(Number(item.credit))
                                  : item.credit}
                                <span className="fs-11 fw-400 gray_color ml-3p"
                                
                                >
                                  {item.communication_type === "call"
                                    ? languageData.communication.call
                                    : languageData.communication.chat}
                                </span>
                              </h3>
                               <div className="flex align-items-start justify-content-between">
                                 <p className="fs-13 mb-2 text-muted">
                                {item.source === "introductory_offer"
                                  ? languageData.offer.introductory_offer
                                  : item.source === "loyalty"
                                    ? languageData.offer.loyalty
                                    : item.source === "sponsorship"
                                      ? languageData.offer.sponsorship
                                      : ""}
                              </p>
                                  {/* Multiple items */}
                            {hasMultipleItems && (
                              <div
                                className="fs-12 text-muted"
                                data-tooltip-id={tooltipId}
                                data-tooltip-place="bottom"
                              >
                                <i className="bi bi-clock"></i>{" "}
                                {languageData.balance.valid}
                                <Tooltip id={tooltipId} style={{zIndex:"99"}}>
                                  {items
                                    .filter((subItem) => subItem.date_end)
                                    .map((subItem, subIndex) => (
                                      <div key={subIndex}>
                                        {item.unit === "period"
                                          ? formatTime(
                                              Number(subItem.remaining),
                                            )
                                          : subItem.remaining}{" "}
                                          {item.communication_type === "call"
                                            ? languageData.communication.call
                                            : item.communication_type === "email"
                                              ? "emails"
                                              : "messages"} {" "}
                                        {languageData.balance.validity}{" "}
                                        {formatDate(subItem.date_end)}
                                      </div>
                                    ))}
                                </Tooltip>
                              </div>
                            )}

                                </div>
                             
                            </div>

                        

                            {/* One item */}
                            {hasOneItem && items[0].date_end && (
                              <div className="fs-12 text-muted">
                                {languageData.balance.validity}{" "}
                                {formatDate(items[0].date_end)}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Balance;
